module.exports = __webpack_public_path__ + "static/media/deleteButton.174e235b.svg";